import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  iconContainer: {
    padding: 5,
  },
  icon: {
    color: "$open_ended_text",
    fontSize: "$media_other_text_icon_size",
  },
  textBoxIcon: {
    alignSelf: "flex-end",
    flexDirection: "row",
  },
  addMedia: {
    position: "absolute",
    top: 0,
    left: 0,
    margin: 10,
  },
});
